module.exports = __webpack_public_path__ + "img/sample-event.b5ce268d.png";